import { render } from "./inner-card.vue?vue&type=template&id=76bcbddd&lang=pug"
import script from "./inner-card.vue?vue&type=script&lang=js"
export * from "./inner-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__